export default __webpack_public_path__ + "static/media/480_business02-jp-mobile.b1abe87f.png";